import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopOnMount from './components/ScrollToTopOnMount';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
// import GalleryPage from './pages/GalleryPage';
import './index.css';
import Loader from './components/LumaLoader';

function AppRoutes() {
  const location = useLocation();

  return (
    <>
      <Routes location={location}>
        <Route path="/" element={<HomePage key="home" />} />
        <Route path="/about" element={<AboutPage key="about" />} />
        <Route path="/services" element={<ServicesPage key="services" />} />
        <Route path="/services/:serviceId" element={<ServiceDetailPage key="service-detail" />} />
        {/* <Route path="/gallery" element={<GalleryPage key="gallery" />} /> */}
        <Route path="/contact" element={<ContactPage key="contact" />} />
      </Routes>
    </>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500); // Simulate loading time
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <Router>
      <ScrollToTopOnMount />
      <div className="App" style={{ position: 'relative' }}>
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999 }}>
          <Header />
        </div>
        <div style={{ position: 'relative' }}>
          <AppRoutes />
          <Footer />
          <ScrollToTop />
        </div>
      </div>
    </Router>
  );
}

export default App;